import React, { Component } from "react";
import { Row, Col, Card, CardHeader, CardBody } from "shards-react";
import Table from 'react-bootstrap/Table'
import axios from 'axios';
import Moment from 'react-moment';
import WebServiceList from '../../webservices/WebServiceList'
import ReactPaginate from 'react-paginate';
import "../../assets/styles.css";


export default class DevicesTable extends Component {

    constructor(props) {
        super(props);
        this.state = {
            devices_list: [],
            data: [],
            itemPerPage: 6,
            PageCount: 0,
            startingIndex: 0,
            endingIndex: 6
        }
    }

    componentDidMount() {

        let theUserEmail = localStorage.getItem("email");
        let theUserId = localStorage.getItem("userId");
        console.log(`theUserEmail:` + theUserEmail);
        console.log(`theUserId:` + theUserId);


        const newUser = {
            userId: theUserId
        }

        let theToken = localStorage.getItem("token");
        const headers = {
            'Content-Type': 'application/json',
            'x-access-token': theToken,
        }; 
        axios.get(WebServiceList.WsGetDevicesList(),{ headers: headers }).then(response => {

            let devices = response.data;
            this.setState({
                devices_list: devices,
                PageCount: Math.ceil(devices.length / this.state.itemPerPage)
            });
            this.onDataChanged();
        }).catch(function (error) {
            console.log("Error:" + error);
        })
    }

    onDataChanged() {
        let theNewList = this.state.devices_list.slice(this.state.startingIndex, this.state.endingIndex);
        this.setState({ data: theNewList })
    }



    deviceList() {
        if (this.state.devices_list && this.state.devices_list.length > 0) {
            return this.state.data.map((device, idx) => (
                <tr key={idx}>
                    <td>{idx + 1 + this.state.startingIndex}</td>
                    <td style={{ width: '30%' }} >{device.device_name}</td>
                    <td style={{ width: '20%' }} > <span className="text-muted" style={{ fontSize: '12px' }} >{device.user.email}</span> </td>
                    <td style={{ width: '30%' }} > <span className="text-muted" style={{ fontSize: '12px' }} >{device.software_version}</span> </td>
                    <td style={{ width: '30%' }}>
                        <Moment format="DD/MM/YYYY HH:mm" >{device.createdAt}</Moment>
                    </td>
                </tr>
            ))
        } else {
            return (<tr className="text-center"><td></td><td></td><td><h4 className="mt-5">Pas de messages</h4></td></tr>)
        }
    }



    handlePageClick = data => {

        let selected = data.selected;
        let offset = Math.ceil(selected * this.state.itemPerPage);

        let theStartingIndex = offset;
        let theEndIndex = offset + this.state.itemPerPage;

        /**
         * This is the key
         */
        this.setState({ data: [] });

        this.setState({ startingIndex: theStartingIndex, endingIndex: theEndIndex }, () => {
            this.onDataChanged();
        });
    };

    render() {
        return (
 
            <Card small className="mb-3 pl-2 pr-2" >
                <CardHeader className="border-bottom">
                    <h6 className="m-0">Liste des appareils</h6>
                </CardHeader>
                <CardBody className="p-0 pb-3 ">
                    <Table className="table mb-1 " responsive="sm" >
                        <thead className="bg-light">
                            <tr>
                                <th scope="col" className="border-0">
                                    #
               </th>
                                <th scope="col" className="border-0">
                                    Nom de l'appareil
               </th>

                                <th scope="col" className="border-0">
                                    E-mail de l'utilisateur
               </th>


                                <th scope="col" className="border-0">
                                   Version logicielle
               </th>
                                <th scope="col" className="border-0">
                                    Dernière connexion
               </th>

                            </tr>
                        </thead>
                        <tbody>

                            {this.deviceList()}

                        </tbody>
                    </Table>
                    <Row className="p-0 m-0">
                        <Col md="7"></Col>
                        <Col md="5">
                            <ReactPaginate
                                previousLabel={'previous'}
                                nextLabel={'next'}
                                breakLabel={'...'}
                                breakClassName={'break-me'}
                                pageCount={this.state.PageCount}
                                marginPagesDisplayed={1}
                                pageRangeDisplayed={1}
                                onPageChange={this.handlePageClick}
                                containerClassName={'pagination'}
                                subContainerClassName={'pages pagination'}
                                activeClassName={'active'}
                            />
                        </Col>
                    </Row>
                </CardBody>
            </Card>



        )
    }

}
